import { ApiProductType } from '@common/enums/api-product-type.enum';
import { StoreModel } from '@common/models';

interface buildProductsUrlParams {
    zipcode: string;
    qteGrpID?: number | null;
    selectedStore: StoreModel;
}

export const buildProductsUrl =
    (productType: ApiProductType) =>
    ({ zipcode, qteGrpID, selectedStore }: buildProductsUrlParams): string => {
        const params = [
            `zipCode=${zipcode}`,
            `storeId=${selectedStore.companyId}`,
            ...(qteGrpID ? [`prodQteGrpID=${qteGrpID}`] : []),
        ];

        return `/products/${productType}?${params.join('&')}`;
    };

export const buildOptionalItemsProductsUrl = buildProductsUrl(ApiProductType.OPTIONAL_ITEMS);
